import { Locale } from 'modules/domains/template';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { QueryLocalesSettingsVariables } from '../../hooks/useQueryLocalesSettings';

export interface LocaleSettingsContextState {
  hasLocales: boolean;
  isLoading: boolean;
  isTemplateDefaultLocaleModifiable: boolean;
  locales: Locale[];
  invalidWhatsAppLocales?: Locale[];
  validWhatsAppLocales?: Locale[];
  refetch: (variables?: Partial<QueryLocalesSettingsVariables> | undefined) => void;
}

export const LocaleSettingsContext = createContext<LocaleSettingsContextState>({
  hasLocales: false,
  isLoading: true,
  isTemplateDefaultLocaleModifiable: false,
  locales: [],
  refetch: noop,
});

export const useLocaleSettingsContext = () => useContext(LocaleSettingsContext);
